import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 触发页面
 */
class TriggerPage extends UltMeta {
    SHIPPINGPLAT = new Meta(1, "船运需求");
    SHIPPINGPLATDETAILS = new Meta(2, "船运需求详情");
    SHIPPINGORDER = new Meta(3, "船运单");
    MYORDER = new Meta(4, "我的报价");
    SHIPPINGAPPLY = new Meta(5, "船舶认证");
}

export const TRIGGER_PAGE = new TriggerPage();

/**
 * 状态
 */
class State extends UltMeta {
    PENDING_PROCESSING = new Meta(1, "待处理");
    PROCESSING = new Meta(2, "处理中");
    PROCESSED = new Meta(3, "已处理", "color-info");
}

export const STATE = new State();

/**
 * 绑定船舶
 */
class ShipBindState extends UltMeta {
    UNBIND = new Meta(0, "否");
    BIND = new Meta(1, "是");
}

export const SHIP_BIND_STATE = new ShipBindState();
